/**
 * Firebase Auth - initialized from config.json at runtime.
 * Returns null if Firebase is not configured.
 */
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId: string;
}

export async function getFirebaseAuth(): Promise<Auth | null> {
  if (auth) return auth;
  try {
    const res = await fetch('/config.json');
    const config = await res.json();
    const fc = config?.FIREBASE as FirebaseConfig | undefined;
    if (!fc?.apiKey || !fc?.projectId) {
      console.warn('[Firebase] Not configured. Add FIREBASE to config.json.');
      return null;
    }
    app = initializeApp(fc);
    auth = getAuth(app);
    return auth;
  } catch (e) {
    console.warn('[Firebase] Failed to init:', e);
    return null;
  }
}

export function getGoogleProvider() {
  return new GoogleAuthProvider();
}

export function getAppleProvider() {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');
  return provider;
}
